import React, { useState, useEffect, useCallback } from 'react'
import {
  Box,
  Text,
  Button,
  FloatingInput,
  Form,
  Loader,
  ThemeContextExtend,
  Captcha,
} from '@usap/uicomponents'
import queryString from 'query-string'
import FormTheme from '../common/config/form-theme'
import { Heading2 } from '../common/heading'
import { trackOrderSchema } from '../common/ValidationSchema'
import validate from '../../helpers/validation'
import CovidMessage from '../common/CovidMessage'
import useIsWmoEnabled from '../../../../carparts/src/shared/hooks/useWmoEnabled'
import TrackOrderWmo from './TrackOrderWmo'

export default function TrackOrder(props) {
  const {
    isDesktop,
    getMyOrder,
    error,
    loading,
    siteKey,
    covidCookie,
  }=props
  const [errors, setError] = useState({})
  const [formData, setFormData] = useState({
    email: '',
    order: '',
  })

  const onInputChangeHandler = event => {
    const { name, value } = event.target
    setError({ ...errors, [name]: '' })
    setFormData({ ...formData, [name]: value })
  }

  const resetClick = (name, event) => {
    // eslint-disable-next-line no-param-reassign
    event.target.name = name
    // eslint-disable-next-line no-param-reassign
    event.target.value = ''
    onInputChangeHandler(event)
    setFormData({ ...formData, [name]: '' })
  }

  const trackMyOrder = ({ email, order }) => {
    getMyOrder(email, order)
  }

  const onFormSubmit = () => {
    const evalidationErrors = validate(formData, trackOrderSchema(formData))
    if (evalidationErrors) {
      return setError(evalidationErrors)
    }
    return trackMyOrder(formData)
  }

  const setCaptchState = useCallback(
    captchaValue => {
      setError({ ...errors, captcha: false })
      setFormData({ ...formData, captcha: captchaValue })
    },
    [errors, formData],
  )

  const isWmoEnabled = useIsWmoEnabled()

  useEffect(() => {
    const parsed = queryString.parse(window.location.search)
    const { emailId = '', orderId = '' } = parsed

    if (emailId && orderId) {
      setFormData({
        email: emailId,
        order: orderId,
      })
    }
  }, [])

  if(isWmoEnabled) {
    return (<TrackOrderWmo {...props}/>)
    }

  return (
    <>
      {loading && <Loader />}
      <ThemeContextExtend value={FormTheme}>
        <Form id="submitForm" onSubmit={onFormSubmit}>
          <Box
            width="640px"
            margin={{
              horizontal: 'auto',
              vertical: 'medium',
            }}
            pad={isDesktop ? 'medium' : 'small'}
            align="center"
            background={isDesktop ? 'light-1' : 'white'}
          >
            <Box width="100%">
              {covidCookie && <CovidMessage borderColor="#4A90E2" />}
              <Box margin={{ vertical: 'small' }}>
                <Heading2 size="small" color="dark-2" title="Track Order" />

                <Text size="xsmall" color="dark-2" margin={{ top: 'xsmall' }}>
                  Track your order now. No sign-in required.
                </Text>
              </Box>

              <Box pad={{ vertical: 'small' }}>
                <FloatingInput
                  style={{ background: 'white' }}
                  label="Email Address"
                  placeholder="Email Address"
                  id="email"
                  name="email"
                  type="email"
                  onChange={onInputChangeHandler}
                  value={formData.email || ''}
                  cross={formData.email}
                  resetClick={event => {
                    resetClick('email', event)
                  }}
                />
                {errors.email && (
                  <Box width="100%">
                    <Text color="#f44635" size="xsmall">
                      Please enter a valid email
                    </Text>
                  </Box>
                )}
              </Box>

              <Box>
                <FloatingInput
                  style={{ background: 'white' }}
                  label="Order ID"
                  placeholder="Order ID"
                  id="order"
                  name="order"
                  type="text"
                  onChange={onInputChangeHandler}
                  value={formData.order || ''}
                  cross={formData.order}
                  resetClick={event => {
                    resetClick('order', event)
                  }}
                />
                {errors.order && (
                  <Box width="100%">
                    <Text color="#f44635" size="xsmall">
                      Please provide a valid Order ID
                    </Text>
                  </Box>
                )}
              </Box>

              <Box pad={{ vertical: 'small' }} align="center">
                <Captcha
                  id="submitform"
                  name="submitform"
                  siteKey={siteKey}
                  setCaptcha={setCaptchState}
                  reset={false}
                  error={errors.captcha}
                />
              </Box>

              <Box
                margin={{
                  top: 'medium',
                  bottom: 'small',
                }}
              >
                <Button
                  id="trackOrder"
                  form="submitForm"
                  primary
                  type="submit"
                  custom
                  hideBorder
                  label="Track Order"
                />
              </Box>

              <Box align="center" height="14px" pad={{ top: 'xsmall' }}>
                <Text color="red" size="xsmall">
                  {error}
                </Text>
              </Box>
            </Box>
          </Box>
        </Form>
      </ThemeContextExtend>
    </>
  )
}
